<template>
  <f7-page :page-content="false" @page:init="onPageInit">
    <f7-navbar :back-link="$t('back')">
      <f7-nav-title>{{ title }}</f7-nav-title>
      <langButton></langButton>
      <f7-subnavbar>
        <f7-segmented strong>
          <f7-button tab-link route-tab-id="tab1" href="./">等待确认</f7-button>
          <f7-button tab-link route-tab-id="tab2" href="tab2/2"
            >已确认</f7-button
          >
          <f7-button tab-link route-tab-id="tab3" href="tab3/3"
            >准备&配送</f7-button
          >
          <f7-button tab-link route-tab-id="tab4" href="tab4/4"
            >已完成</f7-button
          >
        </f7-segmented>
      </f7-subnavbar>
    </f7-navbar>
    <f7-tabs routable animated>
      <f7-tab id="tab1" class="page-content"></f7-tab>
      <f7-tab id="tab2" class="page-content"></f7-tab>
      <f7-tab id="tab3" class="page-content"></f7-tab>
      <f7-tab id="tab4" class="page-content"></f7-tab>
    </f7-tabs>
  </f7-page>
</template>
<script>
import { getShopInfo } from "@/api/api";
import { f7 } from "framework7-vue";
export default {
  props: {
    f7route: Object,
  },
  data() {
    return {
      title: "可派商城订单",
    };
  },
  methods: {
    onPageInit() {
      let para = {
        key: this.f7route.params.shopId,
      };
      getShopInfo(para).then((res) => {
        if (res.data.success) {
          f7.store.dispatch("saveShopMode", res.data.response.Mode);
          this.title = this.$field(res.data.response.Name);
        } else {
          f7.toast
            .create({
              icon: '<i class="f7-icons">multiply</i>',
              text: res.data.msg,
              position: "center",
              closeTimeout: 2000,
            })
            .open();
        }
      });
    },
  },
};
</script>